console.log("ftschematadef JAVASCRIPT version 20260214 032944")

const CONSTANTS = {}
CONSTANTS.RECORDS_MGMT_API = "https://records-mgmt-api.fishtagged.com"
CONSTANTS.ACS_API = "https://access-control-api.fishtagged.com"

function getCookie(name) {
  const cookieString = document.cookie;
  const cookies = cookieString.split("; ");
  for (let cookie of cookies) {
    const [key, value] = cookie.split("=");
    if (key === name) return decodeURIComponent(value);
  }
  return null;
}

function makeHTTPRequest(method, url, requestBody, customHeaders, onReadyStateChangeNot4, onUploadProgress, onSuccess, onFailure, onIOFailure, doNotGoToLoginPageOn401) {
	const xhr = new XMLHttpRequest()
	xhr.open(method, url, true)
	xhr.withCredentials = true
	
	if (onReadyStateChangeNot4 != null) {
		xhr.onreadystatechange = function(){ onReadyStateChangeNot4(xhr.readyState) }
	}
	
	if (onUploadProgress != null) {
		xhr.upload.onprogress = function(event) {
      if (event.lengthComputable) {
        const percentComplete = (event.loaded / event.total) * 100;
        onUploadProgress(percentComplete)
      }
    }
	}

	xhr.onload = function () {
		console.log("[HTTPHandler] HTTP 401 re-login prompt show? ",doNotGoToLoginPageOn401)
		if (xhr.status >= 200 && xhr.status < 300) {
			onSuccess(xhr.responseText)
		} 
		else if (xhr.status === 401 && !doNotGoToLoginPageOn401) {
			const formerType = getCookie("ft_login_type")
			const to_go = formerType === "ADMIN" ? "/login_fa" : "/login_coa"
			if (window.confirm("Login expired or invalid. Open sign-in page?")) {
				window.open(to_go + "?skip_switch_account_modal=TRUE&close_after=TRUE")
			}
		}
		else {
			onFailure(xhr.responseText)
		}
	};

	if (onIOFailure != null) {
		xhr.onerror = function (e) {
			onIOFailure(`{"errors": ["${e}"]}`)
		};
	}
	
	if (customHeaders != null) {
		for (let key in customHeaders) {
			xhr.setRequestHeader(key, customHeaders[key])
		}
	}

	if (requestBody != null) {
		xhr.send(requestBody)
	}
	else {
		xhr.send()
	}
}

class TextSplitter {
	static split(input, separator, limit = -1) {
		  if (limit === 1) return [input];

		  const output = [];
		  let lastIndex = 0;
		  let match;

		  const regex = new RegExp(separator, 'g');

		  while ((match = regex.exec(input)) !== null) {
			if (output.length === limit - 1) {
			  break;
			}
			output.push(input.slice(lastIndex, match.index));
			lastIndex = regex.lastIndex;
		  }

		  output.push(input.slice(lastIndex));

		  return output;
	}
}

/* ================================
 * Individual Validator objects
 * ================================ */

class IntegerValidator {
  constructor(name) {
    this.typename = String(name);
  }

  validate(inp) {
    const value = parseInt(inp, 10);
    if (Number.isNaN(value)) {
      throw new Error(
        `Validation criteria violated for field of type ${this.typename}: could not read input as an integer`
      );
    }
    return value;
  }
}

class FloatValidator {
  constructor(name) {
    this.typename = String(name);
  }

  validate(inp) {
    const value = parseFloat(inp);
    if (Number.isNaN(value)) {
      throw new Error(
        `Validation criteria violated for field of type ${this.typename}: could not read input as a floating point number`
      );
    }
    return value;
  }
}

class TextValidator {
  validate(inp) {
    return String(inp);
  }
}

class DateTimeValidator {
  constructor(name) {
    this.typename = String(name);
  }

  validate(inp) {
    if (inp instanceof Date && !isNaN(inp)) {
      return inp;
    }

    const parsed = new Date(String(inp));
    if (!isNaN(parsed)) {
      return parsed;
    }

    throw new Error(
      `Validation criteria violated for field of type ${this.typename}: input could not be read as a date/time`
    );
  }
}

class NumberRangeValidator {
  constructor(name, floor = null, ceiling = null) {
    this.typename = String(name);
    this.min = floor !== null ? Number(floor) : null;
    this.max = ceiling !== null ? Number(ceiling) : null;
  }

  validate(inp) {
    const value = Number(inp);

    if (this.min !== null && value < this.min) {
      throw new Error(
        `Validation criteria violated for field of type ${this.typename}: Input was less than ${this.min}`
      );
    }

    if (this.max !== null && value > this.max) {
      throw new Error(
        `Validation criteria violated for field of type ${this.typename}: Input was greater than ${this.max}`
      );
    }

    return inp;
  }
}

class BooleanValidator {
  constructor(name) {
    this.typename = String(name);
  }

  validate(inp) {
    const inpType = typeof inp;

    if (inpType === "boolean") {
      return inp;
    }

    if (inpType === "string") {
      const inpUpper = inp.toUpperCase();

      if (
        inpUpper === "TRUE" ||
        inpUpper === "1" ||
        inpUpper === "T" ||
        inpUpper === "YES" ||
        inpUpper === "Y"
      ) {
        return true;
      } else if (
        inpUpper === "FALSE" ||
        inpUpper === "0" ||
        inpUpper === "F" ||
        inpUpper === "NO" ||
        inpUpper === "N"
      ) {
        return false;
      } else {
        throw new Error(
          `Validation criteria violated for field of type ${this.typename}: input string could not be cast to true or false`
        );
      }
    }

    if (inpType === "number") {
      return inp > 0;
    }

    throw new Error(
      `Validation criteria violated for field of type ${this.typename}: input was not a boolean, number, or string representing a boolean`
    );
  }
}

class StringLengthValidator {
  constructor(name, floor, ceiling) {
    if (
      (typeof floor === "number" && !Number.isInteger(floor)) ||
      (typeof ceiling === "number" && !Number.isInteger(ceiling))
    ) {
      throw new Error(
        "String length bounds must be None OR ints, not float"
      );
    }

    this.typename = String(name);
    this.internal_number_range_validator =
      new NumberRangeValidator(`${this.typename}'s length`, floor, ceiling);
  }

  validate(inp) {
    const str = String(inp);
    this.internal_number_range_validator.validate(str.length);
    return inp;
  }
}

class RegexValidator {
  constructor(name, regexp) {
    this.typename = String(name);
    this.regex = String(regexp);

    try {
      new RegExp(this.regex);
    } catch (e) {
      throw new Error("Invalid regexp pattern supplied on validator creation");
    }
  }

  validate(inp) {
    const str = String(inp);
    const re = new RegExp(this.regex);

    if (re.test(str)) {
      return str;
    }

    throw new Error(
      `Validation criteria violated for field of type ${this.typename}: input did not comply with the regular expression pattern ${this.regex}`
    );
  }
}

class EnumeratedTypeValidator {
  constructor(name, enum_options) {
    this.typename = String(name);

    if (!Array.isArray(enum_options)) {
      throw new Error("A non-list was passed to the constructor");
    }

    this.allowable_values = enum_options;
  }

  validate(inp) {
    const value = String(inp);

    if (!this.allowable_values.includes(value)) {
      throw new Error(
        `Validation criteria violated for field of type ${this.typename}: Input was not one of the following: ${this.allowable_values}`
      );
    }

    return inp;
  }
}

/* ================================
 * Type class
 * (NOTE: LOAD_EXTERNAL_TYPES and LOAD_EXTERNAL_TYPES_NS are removed as commands
 * since there isn't a way to load in local files here.)
 * ================================ */

class Type {
  constructor(validators, cast_type = null) {
    if (!Array.isArray(validators)) {
      throw new Error("Invalid validator list supplied");
    }

    this.validator_list = validators;
    this.explicit_cast_type = cast_type !== null ? String(cast_type) : null;
  }

  input_is_ok(inp) {
    let current = inp;

    for (const validator of this.validator_list) {
      try {
        current = validator.validate(current);
      } catch (e) {
        try {
          return [false, TextSplitter.split(e.message, ": ", 2)[1]];
        } catch {
          return [false, e.message];
        }
      }
    }

    return [true, current];
  }
}

/* ================================
 * TypeReader
 * ================================ */

class TypeReader {
  static CONVERTERS = {
    INTEGER: IntegerValidator,
    FLOAT: FloatValidator,
    TEXT: TextValidator,
    DATETIME: DateTimeValidator,
	BOOLEAN: BooleanValidator
  };

  static types = {};

  static parse_into_type_objects(c, namespace = null) {
    const lines = TextSplitter.split(c, "\n");
	console.log(`******* NEW LOAD INTO NS ${namespace} *******`);
	console.log(`Reading ${lines.length} lines of ft-type commands...`);
    let current_field_name = null;
    let current_line_number = 0;

    while (current_line_number < lines.length) {
      const line = lines[current_line_number];

      if (line.trim().startsWith("//") || line.trim().length === 0) {
        current_line_number++;
        continue;
      }

      let command, args;
      try {
        [command, args] = TextSplitter.split(line.trim(), " ", 2);
        command = command.trim();
        args = args.trim();
        console.log(`(Line ${current_line_number}):`, command, args);
      } catch {
        throw new SyntaxError(
          `(Line ${current_line_number}) Command but no args: ${line}`
        );
      }

      if (command === "DEFINE_TYPE" || command === "TDEF") {
        current_field_name =
          namespace !== null ? `${namespace}.${args}` : args;
        TypeReader.types[current_field_name] = new Type([]);
        console.log("    Writing to type:", args);

      }  
	  else if (current_field_name === null) {
        throw new SyntaxError(
          `(Line ${current_line_number}) No field currently selected, run DEFINE_TYPE before running ${command}`
        );

      } else if (command === "END_DEFINE_TYPE" || command === "TCLOSE") {
        console.log("    Type closed:", args);
        current_field_name = null;

      } else if (command === "DECLARE_AS_ENUM_TYPE" || command === "ENUM") {
        const [db_type, options] = TextSplitter.split(args, " ", 2);
        console.log("    Creating enum type castable to:", db_type);

        const typeObj = TypeReader.types[current_field_name];

        if (typeObj.explicit_cast_type === null) {
          typeObj.explicit_cast_type = db_type;
        } else {
          throw new SyntaxError(
            `(Line ${current_line_number}) This type already has a SQL cast type of ${typeObj.explicit_cast_type}`
          );
        }

        const option_list = TextSplitter.split(options, ",").map(o => o.trim());
        console.log("    Enum values:", option_list);

        typeObj.validator_list.push(
          new EnumeratedTypeValidator(current_field_name, option_list)
        );
		TypeReader.types[current_field_name].allowed_options = option_list;

      } else if (command === "CONVERT_INTO" || command === "CONV") {
        const converter = TypeReader.CONVERTERS[args];
        if (!converter) {
          throw new SyntaxError(
            `(Line ${current_line_number}) Invalid conversion type: ${args}`
          );
        }

        console.log("    Selected converter:", converter.name);
        TypeReader.types[current_field_name].validator_list.push(
          new converter(current_field_name)
        );

      } else if (command === "CHECK" || command === "CHK") {
        const [check_type, params] = TextSplitter.split(args, " ", 2);

        if (check_type === "IN_RANGE") {
          let [floor, ceiling] = params.split(" ", 2);
          if (floor === "*") floor = null;
          if (ceiling === "*") ceiling = null;

          console.log("    Numerical range:", floor, ceiling);
          TypeReader.types[current_field_name].validator_list.push(
            new NumberRangeValidator(current_field_name, floor, ceiling)
          );

        } else if (check_type === "STRING_LENGTH_IN_RANGE") {
          let [floor, ceiling] = TextSplitter.split(params, " ", 2);
          if (floor === "*") floor = null;
          if (ceiling === "*") ceiling = null;

          console.log("    String length range:", floor, ceiling);
          TypeReader.types[current_field_name].validator_list.push(
            new StringLengthValidator(current_field_name, floor, ceiling)
          );

        } else if (check_type === "MATCHES_REGEXP_ECMASCRIPT") {
          console.log("    Regexp check:", params);
          TypeReader.types[current_field_name].validator_list.push(
            new RegexValidator(current_field_name, params)
          );

        } else if (check_type === "MATCHES_REGEXP_PYTHON") {
		      console.log("    Ignoring...")
		} else {
          throw new SyntaxError(
            `(Line ${current_line_number}) Invalid check type: ${check_type}`
          );
        }

      } else {
        throw new SyntaxError(
          `(Line ${current_line_number}) Invalid command: ${command}`
        );
      }

      current_line_number++;
    }
	console.log(`Final result of type loading: `,TypeReader.types)
  }
}

class RemoteTypeLoader {
	static loadNamespaces(namespaces, onSuccess) {
		makeHTTPRequest(
			"GET",
			`${CONSTANTS.RECORDS_MGMT_API}/ft-types?namespaces=${namespaces}`,
			null,
			null,
			null,
			null,
			function (responseText) {
				const loadedNamespaces = JSON.parse(responseText)["return_payload"]["namespaces"]
				for (let key in loadedNamespaces) {
					TypeReader.parse_into_type_objects(loadedNamespaces[key], key)
				}
				console.log("Current types loaded: ", TypeReader.types)
				if (onSuccess != null) {
					onSuccess()
				}
			}, 
			function (responseText) {
				alert(`NOTICE! FTSchemataDef failed to load types with namespaces ${namespaces} due to an HTTP error`);
			},
			function (err) {
				alert(`NOTICE! FTSchemataDef failed to load types with namespaces ${namespaces} due to an IO error`);
			}
		)
	}
}

const types = TypeReader.types
export { types, RemoteTypeLoader, TextSplitter, RegexValidator, EnumeratedTypeValidator, StringLengthValidator, BooleanValidator, NumberRangeValidator, DateTimeValidator, TextValidator, FloatValidator, IntegerValidator, TypeReader }